module.exports = "/images/icon_arrow_02.png?7e6ee460123843bf73aa7762130645ca";